"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { motion } from "motion/react";
import type { ProjectDetail } from "@/types/projects";
import { shimmer } from "@/lib/shimmer";
export function ProjectCard(t0) {
  const $ = _c(28);
  const {
    project
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      duration: 0.5
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = project.link;
  const t5 = `${project.slug}`;
  const t6 = project.homeImageUrl ?? "/doge-troubleshoot.jpg";
  const t7 = project.title;
  let t8;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = shimmer([768, 1024]);
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== project.title || $[5] !== t6) {
    t9 = <Image src={t6} alt={t7} width={768} height={1024} placeholder="blur" blurDataURL={t8} className="object-contain group-hover:scale-[1.005] brightness-90 transition-all duration-500 group-hover:brightness-100" />;
    $[4] = project.title;
    $[5] = t6;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="absolute inset-0 flex flex-col justify-end"><div className="from-background/80 to-background/40 md:h-[20%] h-[28%] bg-gradient-to-t backdrop-blur-xs sm:h-1/4" /></div>;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== t9) {
    t11 = <div className="transition-transform duration-500">{t9}{t10}</div>;
    $[8] = t9;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  let t13;
  let t14;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: 0,
      y: 10
    };
    t13 = {
      opacity: 1,
      y: 0
    };
    t14 = {
      delay: 0.2
    };
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
  } else {
    t12 = $[10];
    t13 = $[11];
    t14 = $[12];
  }
  let t15;
  if ($[13] !== project.title) {
    t15 = <motion.h2 className="font-basis-grotesque-pro font-bold text-base tracking-wider sm:text-2xl" initial={t12} animate={t13} transition={t14}>{project.title}</motion.h2>;
    $[13] = project.title;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  let t17;
  let t18;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      opacity: 0,
      y: 10
    };
    t17 = {
      opacity: 1,
      y: 0
    };
    t18 = {
      delay: 0.3
    };
    $[15] = t16;
    $[16] = t17;
    $[17] = t18;
  } else {
    t16 = $[15];
    t17 = $[16];
    t18 = $[17];
  }
  let t19;
  if ($[18] !== project.description) {
    t19 = <motion.p className="font-basis-grotesque-pro font-normal text-muted-foreground mt-2 text-sm tracking-wider" initial={t16} animate={t17} transition={t18}>{project.description}</motion.p>;
    $[18] = project.description;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] !== t15 || $[21] !== t19) {
    t20 = <div className="text-foreground absolute right-0 bottom-0 left-0 p-6">{t15}{t19}</div>;
    $[20] = t15;
    $[21] = t19;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  let t21;
  if ($[23] !== project.link || $[24] !== t11 || $[25] !== t20 || $[26] !== t5) {
    t21 = <motion.div initial={t1} animate={t2} transition={t3} className="group relative aspect-[3/4]! max-w-[calc(100vw-10vw)] overflow-hidden  mx-auto"><Link href={t4} id={t5} className="relative block h-full">{t11}{t20}</Link></motion.div>;
    $[23] = project.link;
    $[24] = t11;
    $[25] = t20;
    $[26] = t5;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  return t21;
}